// contexts/LayoutContext.tsx
import React, { createContext, useContext, ReactNode } from 'react';

interface LayoutContextType {
  sidebarCollapsed: boolean;
  isMobile: boolean;
  sidebarWidth: number;
  ticketDetailsOpen: boolean;
  ticketDetailsWidth: number;
}

const LayoutContext = createContext<LayoutContextType>({
  sidebarCollapsed: false,
  isMobile: false,
  sidebarWidth: 280,
  ticketDetailsOpen: false,
  ticketDetailsWidth: 600,
});

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

interface LayoutProviderProps {
  children: ReactNode;
  value: LayoutContextType;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children, value }) => {
  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};